import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";

type ResultCountLabelProps = {
  end: number;
  start: number;
  total: number;
};

/** Renders the "Showing 1-10 of 42" count above and below the listings table. */
export const ResultCountLabel = ({
  end,
  start,
  total,
}: ResultCountLabelProps) => (
  <Text className="text-gray-dark">
    <FormattedMessage
      id="hosting.my_listings.result_count"
      defaultMessage="Showing {start}-{end} of {total}"
      values={{ start, end, total }}
    />
  </Text>
);
